import { render, staticRenderFns } from "./MarkAsSeenButton.vue?vue&type=template&id=b3168c00&scoped=true"
import script from "./MarkAsSeenButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./MarkAsSeenButton.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3168c00",
  null
  
)

export default component.exports